import { useEffect, useState } from "react";
import { LoyaltyOrderHistoryModel } from "../../models";
import { useAuth, useStore } from "../../hooks";
import { GetUserLoyaltyOrdersApi } from "../../services";
import { formatDate } from "../../utilities";

const LoyaltyPointsHistory = () => {
  const { storeId } = useStore();
  const { customerId } = useAuth();

  const [orders, setOrders] = useState<LoyaltyOrderHistoryModel[]>([]);

  useEffect(() => {
    async function fetchData() {
      const { status, data } = await GetUserLoyaltyOrdersApi({
        store_id: storeId,
        customer_id: customerId,
      });
      if (status) setOrders(data);
    }

    fetchData();
  }, []);

  if (!orders.length) return <></>;

  return (
    <>
      <h3>Points History </h3>
      <div className="loyalty_sec2">
        <ul>
          {orders.map((order, index) => {
            const isEarned = Number(order.points) > 0;
            return (
              <li key={index}>
                <div className="history_row">
                  <div className="earned_row d-flex align-items-center">
                    <div
                      className={`history_icon ${isEarned ? "earned" : "used"}`}
                    >
                      {isEarned ? "+" : "−"}
                    </div>

                    <div>
                      <h5>
                        You {Number(order.points) > 0 ? "earned" : "used"}{" "}
                        {Math.abs(Number(order.points))} points
                      </h5>
                      <p>
                        <i>Order No</i> {order.order_id} <i>on</i>{" "}
                        {formatDate(order.created_at)}
                      </p>
                    </div>
                  </div>
                  <span>{order.points}</span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default LoyaltyPointsHistory;
